import type { Editor } from '@tiptap/react';
import { EditorContent } from '@tiptap/react';

import type { Control } from 'react-hook-form';

import { Controller } from 'react-hook-form';

import { z } from 'zod';

import { MultiGroupFilter } from '@/components/multi-group/MultiGroupFilter';
import { EditorMenu } from '@/modules/editor/menu/EditorMenu';
import { Or2BubbleMenu } from '@/modules/editor/bubble-menu/Or2BubbleMenu';
import type { PostsEnabledFilterGroup } from '@/modules/post/CreatePostModal';

export const ShareToNoticeboardSchema = z.object({
  htmlContent: z.string(),
  groups: z.array(z.string()).min(1, 'Please select at least one group'),
});

export type ShareToNoticeboardFormData = z.infer<
  typeof ShareToNoticeboardSchema
>;

interface Props {
  control: Control<ShareToNoticeboardFormData>;
  editor: Editor | null;
  groupOptions: PostsEnabledFilterGroup[];
}

export const ShareToNoticeboardForm = ({
  control,
  editor,
  groupOptions,
}: Props) => {
  return (
    <div>
      <Or2BubbleMenu editor={editor} disableFileSelector />
      <EditorContent editor={editor} />
      <EditorMenu editor={editor} disableFileSelector />
      <Controller
        name="groups"
        control={control}
        render={({ field, fieldState }) => {
          const selectedOptions = groupOptions.filter((option) =>
            field.value.some((value) => value === option._id),
          );

          return (
            <MultiGroupFilter
              label="Your message will be posted on the noticeboard of the following boards or groups"
              placeholder="Click here to modify"
              groupOptions={groupOptions}
              selectedOptions={selectedOptions}
              textFieldProps={{
                error: Boolean(fieldState.error),
                helperText: fieldState.error?.message,
              }}
              loading={false}
              onChange={(selectedOptions) => {
                field.onChange(selectedOptions.map((option) => option._id));
              }}
            />
          );
        }}
      />
    </div>
  );
};
